import MatterNotes from "@/components/features/matter/notes/MatterNotes";
import { Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { type Matter, type MatterNote } from "@/lib/types";
import { useState } from "react";

export default function MatterNotesContainer({
  notes,
  matter,
  massTortId,
}: {
  notes: MatterNote[];
  matter: Matter;
  massTortId?: string;
}) {
  const { hasPagePermission } = useUser();
  const hasViewPermission = hasPagePermission(
    massTortId
      ? PAGE_PERMISSION_KEYS.massTortsDetailNotes
      : PAGE_PERMISSION_KEYS.mattersDetailNotes,
  );
  const [notesApiCount, setNoteCount] = useState<number | undefined>();
  const noteCount = notesApiCount;

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-y-4 p-6">
      <Text variant="title">
        {hasViewPermission
          ? `Notes${noteCount === undefined ? "" : ` (${noteCount})`}`
          : "Notes"}
      </Text>
      <div className="flex min-h-0 flex-1 flex-col">
        <MatterNotes
          notes={notes}
          matter={matter}
          massTortId={massTortId}
          onNoteCountChange={setNoteCount}
        />
      </div>
    </div>
  );
}
